/** Where the Dabba API lives. Production builds set VITE_API_URL. */
export const API_URL: string = import.meta.env.VITE_API_URL ?? 'http://localhost:4000';
export const WS_URL: string = API_URL.replace(/^http/, 'ws') + '/ws';
export const APP_VERSION = '1.0.0';
